const log = (message, details = {}, color = '#a2dbff') => {
  console.groupCollapsed(`%c${message}`, `color: ${color}; font-weight: bold;`);

  if (details) {
    console.log('details:', details);
  }

  console.groupEnd();
};

module.exports = {
  log,
};
